import { useEffect, useState } from "react"

import { Obj, load, navigateTo } from "scrivito"
import { ProjectPageObjClass } from "scrivito/Objs/ProjectPage/ProjectPageObjClass"
import { useEvent } from "shared/lib/useEvent"

import { useProject } from "features/project-management/model/useProject"
import { ProjectModel } from "features/project-management/types/ProjectModel"

export interface ProjectsOverviewCardModelProps {
  projectID: string
}

export function useProjectsOverviewCardModel({
  projectID
}: ProjectsOverviewCardModelProps): ProjectModel {
  const model = useProject(
    { projectID },
    { includePrice: false, includeChildren: false, includeTeam: false }
  )

  const [to, setTo] = useState<null | Obj>(null)
  useEffect(() => {
    load(() => ProjectPageObjClass.all().first()).then(obj => setTo(obj))
  }, [projectID])

  const navigate = useEvent(() => {
    navigateTo(to, { params: { project_id: projectID } })
  })

  return {
    ...model,
    core: {
      ...model.core,
      handlers: {
        ...model.core.handlers,
        onOpen: to ? navigate : undefined
      }
    }
  }
}
